const data = JSON.parse(sessionStorage.getItem("data"));

if (data){
   var { skpd, opd, user } = JSON.parse(sessionStorage.data);
}

export function isLogged(){
   return data ? true : false;
}

export function getTahunAnggaran(){
   return isLogged() ? user.tahun : null
}

export function getToken(){
   return isLogged() ? user.access_token : null
}

export function getUser(){
   return isLogged() ? user.username : null
}

export function isAdmin(){
   return isLogged() ? user.is_admin : false;
}

export function isBank(){
   return isLogged() ? user.is_bank : false;
}

export function isOpd(){
   return isLogged() ? user.is_opd : false;
}

export function isVerificator(){
   return isLogged() ? user.is_verificator : false;
}

export function onLogout(){
   sessionStorage.removeItem('data');
   return "/";
}

export function fetchSKPD(){
   return skpd;
}

export function getSKPD(kode){
   for(let i=0; i<skpd.length; i++) {
      if(skpd[i]["kode_skpd"].indexOf(kode)!==-1) {
         return skpd[i].skpd
      }
   }
}

export function getOPD(kode){
   for(let i=0; i<opd.length; i++) {
      if(opd[i]["kode_opd"].indexOf(kode)!==-1) {
         return opd[i].opd;
      }
   }
}

export function filterOPD(kode){
   var result = [];
   if(kode===10000 || kode===null){
      result = []
   }else{
      result.push({'value':10000,'text':"Semua OPD",'key':10000})
      for(let i=0; i<opd.length; i++) {
         if(opd[i]["kode_skpd"].indexOf(kode)!==-1) {
            result.push({
               'value': i+1,
               'text': `[${opd[i].kode_opd}] ${opd[i].opd}`,
               'key': opd[i].kode_opd,     
            })
         }
      }
   }
   return result;
}

export function fetchOPD(){
   return opd;
}



// WEBPACK FOOTER //
// ./src/_utils/localstorage.js